<section class="smart-way-wrapper " id="feature">
    <div class="container ">
        <div class="mb-5 text-center text-lg-start  d-block d-md-none">
            <img src="/assets/images/smart-avtar-img.svg" class="img-fluid smart-avtar" alt="">
           </div>
        <h2 class=" fw-semibold mt-5 mb-5 font-48 text-blue text-center ">
          {{"smart_way_title"|translate}}
        </h2>
        <p class="text-center fw-medium font-20 text-dark-blue pb-5 mb-0 mb-md-4 ">
            {{"smart_way_subtitle"|translate}}
        </p>

        <div class="row align-items-center d-none d-sm-flex">
            <div class="col-md-4 order-2 order-md-1">
                <div class="way-info">
                   <div class="d-flex align-tems-center justify-content-start justify-content-sm-end mb-4 pb-md-4 text-center text-md-end" *ngFor="let item of smart_way_one">
                    <span class="d-inline-block d-sm-none font-16 text-primary me-3">{{item.no}}</span>
                    <p class="text-dark-blue font-20 pt-0 fw-regular mb-0">{{item.para | translate}}</p>
                  </div>
                </div>
            </div>
            <div class="col-md-4 order-1 order-md-2">
                <div class="my-4 text-center text-lg-start ps-lg-4 ms-lg-3 d-none d-md-block">
                 <img src="/assets/images/smart-avtar-img.svg" class="img-fluid" alt="">
                </div>
            </div>
            <div class="col-md-4 order-3 order-md-3">
                <div class="way-info">
                    <div class="d-flex align-tems-center mb-4 pb-md-4" *ngFor="let item of smart_way_two">
                     <span class="d-inline-block d-sm-none font-16 text-primary me-3">{{item.no}}</span>
                      <p class="text-dark-blue font-20 pt-0 fw-regular  mb-0">{{item.para | translate}}</p>
                    </div>
                </div>
            </div>
            <!-- <div class="col-md-12 text-center">
                <a  class="btn btn-primary mt-5" (click)="scrollTop()" translate>join_waitlist</a>
            </div> -->
        </div>
    </div>
    <div class="d-block d-sm-none smart-slider mb-4 position-relative"  >
        <owl-carousel-o  [options]="smartest" (translated)="getPassedData($event)" #carousel >
            <ng-template carouselSlide *ngFor="let items of smart_way; let i = index;" dataHash="one">
                    <div class="way-info text-center py-3" >
                        <span class="d-inline-block d-sm-none font-16 text-dark-blue fw-medium">{{items.no}}</span>
                        <p class="text-dark-blue font-16 pt-0 fw-medium  mb-0">{{items.para | translate}}</p>
                    </div>
            </ng-template>
        </owl-carousel-o>  
         <!-- <div class="text-center control-btn mt-5">
          <a (click)="carousel.prev();selectTo(carousel)" class="prev-btn mx-2 cursor-pointer" *ngIf="!startPosition"><img src='/assets/images/prev-arrow.svg'></a>
          <a (click)="carousel.next();selectTo(carousel)" class="next-btn mx-2 cursor-pointer" *ngIf="startPosition"><img src='/assets/images/next-arrow.svg'></a>
        </div> -->
    </div>
</section>
